<template>
  <div class="coach-index">
    <div class="avatar">
      <img :src="coach.avatar" title="头像">
    </div>
    <weui-button type="default" class="change-avatar" id="uploader">
      <uploader @input="onUploaded" />
    </weui-button>
    <weui-group>
      <weui-input label="称呼" v-model="coach.name" />
      <weui-cell label="性别" :text="formatGender(coach.gender)" :link="true" @click="selectGender" />
      <weui-cell label="手机号码" :text="coach.phone" :link="{ name: ROUTE_COACH_PHONE }" />
    </weui-group>
    <weui-group title="每天约课时间">
      <weui-cell label="开始" :text="formatTime(coach.course_start_time)" :link="true" @click="selectStartTime" />
      <weui-cell label="结束" :text="formatTime(coach.course_end_time)" :link="true" @click="selectEndTime" />
    </weui-group>
    <weui-group>
      <weui-switch label="每节课前提醒我" v-model="coach.notify_before_course" />
      <weui-switch label="允许用户查看我的日程安排" v-model="coach.course_time_publicly" />
      <weui-cell text="问题及建议" :link="true" />
    </weui-group>
    <weui-button-area>
      <weui-button type="primary" @click="saveCoach">保存设置</weui-button>
      <weui-button type="warn" @click="signOut">退出登录</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from '@/wechat/weui';

import auth from '@/auth';
import { WeuiGroup, WeuiCell, WeuiInput, WeuiSwitch, WeuiButtonArea, WeuiButton } from '@/components/weui';
import Uploader from '@/components/coach/Uploader';

import { GENDER_MALE, GENDER_FEMALE } from '@/constants/types';
import { ROUTE_COACH_PHONE } from '@/router/names';
import { PATCH_COACH, WECHAT_UNBIND_COACH } from '@/store/coach/types';
import mixinUniqid from '@/mixins/uniqid';
import mixinFormatters from '@/mixins/formatters';
import datetimeUtils from '@/utils/datetime';

const { mapState, mapActions } = createNamespacedHelpers('coach');

export default {
    data() {
        return {
            ROUTE_COACH_PHONE,
        };
    },
    computed: {
        ...mapState({
            coach: state => state.coach || {},
        }),
    },
    methods: {
        ...mapActions({
            patchCoach: PATCH_COACH,
            wechatUnbind: WECHAT_UNBIND_COACH,
        }),
        onUploaded(url) {
            this.coach.avatar = url;
        },
        async selectGender() {
            const result = await weui.picker([
                { label: '男', value: GENDER_MALE },
                { label: '女', value: GENDER_FEMALE },
            ], {
                defaultValue: [this.coach.gender],
            });
            if (result !== false) {
                this.coach.gender = result[0].value;
            }
        },
        buildTimeOptions(start, end) {
            const startTs = datetimeUtils.fromTimeString(start);
            const endTs = datetimeUtils.fromTimeString(end);
            const options = [];
            for (let ptrTs = startTs; ptrTs <= endTs; ptrTs += 1800) {
                const time = datetimeUtils.toTimeString(ptrTs);
                options.push({
                    label: this.formatTime(time),
                    value: time,
                });
            }
            return options;
        },
        async selectStartTime() {
            const options = this.buildTimeOptions('06:00', '23:30');
            const result = await weui.picker(options, {
                defaultValue: [this.coach.course_start_time],
            });
            if (result !== false) {
                this.coach.course_start_time = result[0].value;
            }
        },
        async selectEndTime() {
            const options = this.buildTimeOptions('06:30', '24:00');
            const result = await weui.picker(options, {
                defaultValue: [this.coach.course_end_time],
            });
            if (result !== false) {
                this.coach.course_end_time = result[0].value;
            }
        },
        saveCoach() {
            this.patchCoach(this.coach)
                .then(() => {
                    weui.toast('保存成功');
                });
        },
        async signOut() {
            const result = await weui.confirm('确认退出登录当前教练吗？');
            if (result) {
                await this.wechatUnbind();
                auth.logoff();
                this.$router.go(0);
            }
        },
    },
    mixins: [
        mixinUniqid,
        mixinFormatters,
    ],
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiInput,
        WeuiSwitch,
        WeuiButtonArea,
        WeuiButton,
        Uploader,
    },
};
</script>

<style lang="scss" scoped>
.avatar {
    width: 100vw;
    height: 100vw;
    > img {
        width: 100%;
        height: 100%;
    }
}

.change-avatar {
    background-color: white;
    color: #02bb00;
}
</style>



// WEBPACK FOOTER //
// src/containers/coach/Index.vue